<template>
	<div class="page flex-column flex-center">
		<h1>欢迎使用<span>蜂鸟工单数字大屏</span></h1>
		<div class="flex">
			<div class="code">
				<c-qrcode class="code-image" :value="qrcode" size="360" padding="20"></c-qrcode>
				<p>请使用<span>微信扫一扫</span>登录</p>
			</div>
			<ul>
				<li class="flex">
					<div class="icon flex-center"><i class="tf">&#xe7fe;</i></div>
					<div>
						<h5>生产数据可视化，产线状态一目了然</h5>
						<p>管理人员不用挨个巡线，站在大屏前就能掌握整条车间运行全貌</p>
					</div>
				</li>
				<li class="flex">
					<div class="icon flex-center"><i class="tf">&#xe68f;</i></div>
					<div>
						<h5>生产异常自动预警，快速处置</h5>
						<p>设备故障、产能缺口、不良率超标、物料缺料等异常自动标红提醒</p>
					</div>
				</li>
				<li class="flex">
					<div class="icon flex-center"><i class="tf">&#xeb95;</i></div>
					<div>
						<h5>辅助生产调度，提升产线利用率</h5>
						<p>横向对比各产线效率，灵活调整工单、调配人员与物料，均衡产线负荷</p>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				qrcode: '',
				code: ''
			}
		},

		mounted() {
			this.getCode();
		},

		beforeDestroy() {
			clearTimeout(this._codeTimer);
			clearTimeout(this._checkTimer);
			this._codeRequest && this._codeRequest.abort();
			this._checkRequest && this._checkRequest.abort();
		},

		methods: {
			getCode() {
				this._codeRequest = this.request({
					url: '/digital/qr_code/info',
					success: data => {
						this.qrcode = `${data.login_url}/${data.qr_code}`;
						this.code = data.qr_code;
						this._codeTimer = setTimeout(this.getCode, (data.expire_time - 120) * 1000);
						
						clearTimeout(this._checkTimer);
						this._checkRequest && this._checkRequest.abort();
						this.checkCode();
					}
				});
			},
			
			checkCode() {
				this._checkRequest = this.request({
					url: '/digital/qr_code/login/check',
					data: {
						qr_code: this.code
					},
					success: data => {
						if (data) {
							this.$store.dispatch('setLoginInfo', data);
							this.redirectTo(`/digital/${data.digital_id}`);
						} else {
							this._checkTimer = setTimeout(this.checkCode, 1000);
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.page {
		position: relative;
		height: 100vh;
		overflow: hidden;
		color: #fff;
		background-color: #0B181E;
		background-image: url('~@/assets/image/login_digital_bg.jpg');
		background-size: cover;

		h1 {
			margin-bottom: 100px;
			font-size: 80px;

			span {
				color: var(--color-main);
			}
		}

		.code {
			margin-right: 76px;
			font-size: 30px;
			text-align: center;
			
			&-image {
				border-radius: 12px;
				margin-bottom: 26px;
			}

			span {
				color: var(--color-main);
			}
		}

		ul {
			margin-top: 36px;

			li {
				margin-bottom: 54px;

				.icon {
					width: 40px;
					height: 40px;
					border-radius: 50%;
					margin-right: 18px;
					font-size: 18px;
					background: #DC9600;
				}

				h5 {
					margin-bottom: 10px;
					line-height: 34px;
					font-size: 24px;
				}

				p {
					font-size: 14px;
					opacity: .6;
				}
			}
		}
	}
</style>
